<template lang="pug">
  el-main(class="main" )
    router-view
</template>

<script>
export default {
  name: "CommonRouterView",
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  methods: {}
};
</script>

<style scoped lang="scss">
.main {
  height: 100%;
}
</style>
